(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('GroupMemory', GroupMemory);

    GroupMemory.$inject = ['$resource', '$q', 'Memory', 'Outing'];
    function GroupMemory($resource, $q, Memory, Outing) {
        var resource;
        resource = $resource('', null, { query: { method: 'GET', isArray: true, interceptor: { request: transformRequest, response: transformReponse } } });
        return resource;

        function transformRequest(config) {
            return angular.extend(config, { cache: { get: getGroupMemories.bind(null, config.params.groupId) } });
        }

        function tommorrow() {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            return date;
        }

        function getGroupMemories(groupId) {
            var promises,
                startOn = tommorrow().toJSON().substr(0, 10);

            promises = {
                memories: Memory.queryByGroup({ groupId: groupId }).$promise,
                outings: Outing.query({
                    $filter: "groupId eq {0} and status eq 'Active' and startOn lt {1}".format(groupId, startOn),
                    $expand: 'createdBy($select=firstName,lastName),gameCourses($select=name),memories($top=1)'
                }).$promise
            };

            return $q.all(promises).then(mergeData);

            function mergeData(res) {
                var result = res.memories.concat(res.outings.map(mapOuting));
                result.sort(sort);
                return { data: result.map(mapResults), status: 200, statusText: 'OK', headers: angular.noop };

                function mapResults(resource) {
                    return { __: resource }
                }

                function mapOuting(outing) {
                    var createdBy = outing.createdBy;
                    if (createdBy)
                        outing.createdBy = ((createdBy.firstName || '') + ' ' + (createdBy.lastName || '')).trim() || 'John Doe';
                    return outing;
                }

                function sort(a, b) {
                    return (b.startOn || b.createdOn) - (a.startOn || a.createdOn);
                }
            }
        }

        function transformReponse(response) {
            var resource = response.resource,
                data = response.resource.map(map);

            resource.length = 0;
            resource.push.apply(resource, data);
            return resource;

            function map(resource) {
                return resource.__;
            }
        }
    }
})();